import { Select } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './LoanFields.module.css';
import { LOAN_PURPOSE_OPTIONS_UK, TLoanFieldsDataUK } from './loanOptions';

type TProps = {
  placeholder?: string;
};

const LoanPurposeUK = ({ placeholder = 'Please select' }: TProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TLoanFieldsDataUK>();

  return (
    <Select
      {...register('loanPurpose')}
      label="How will you use the funds?"
      placeholder={placeholder}
      className={clsx({
        [styles.erroredSelect]: errors.loanPurpose?.message,
      })}
      error={errors.loanPurpose?.message}
    >
      {LOAN_PURPOSE_OPTIONS_UK.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default LoanPurposeUK;
